import { useDataFetch } from '../../../hooks/use-data-fetch';

// Interfaces para las direcciones
export interface City {
  name: string;
  id: string;
  created_at: string;
  shippingCost?: number;
}

export interface Province {
  name: string;
  id: string;
  created_at: string;
}

export interface Country {
  name: string;
  id: string;
  shippingCost?: number;
}

export interface Address {
  id: string;
  user_id: string;
  name: string;
  address: string;
  country_id: Country;
  province_id: Province;
  city_id: City;
  postal_code: string;
  observations?: string;
  status: boolean;
  created_at: string;
  createdAt: string;
  updatedAt: string;
}

export interface AddressesResponse {
  data: {
    addresses: Address[];
  };
  errors: null | any;
}

/**
 * Hook personalizado para obtener las direcciones del usuario
 * @returns Objeto con las direcciones y el estado de la consulta
 */
export const useAddresses = () => {
  const { getData } = useDataFetch();
  
  // Utilizamos el hook useGetData para hacer la petición GET al endpoint
  const query = getData(
    ['userAddresses'],
    '/address',
    {
      // Opciones adicionales de la consulta
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 minutos
      gcTime: 1000 * 60 * 10 // 10 minutos (anteriormente cacheTime)
    }
  );

  // Extraer las direcciones de la respuesta
  const addresses = query.data?.data?.addresses || [];
  
  return {
    addresses,
    ...query
  };
};
